module.exports = __webpack_public_path__ + "static/media/ps-crashcourse800w.3ffd0ab4.png";